var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "bg-white", attrs: { "fill-height": "", fluid: "" } },
    [
      _c(
        "v-row",
        { staticStyle: { "margin-top": "-10%" }, attrs: { justify: "center" } },
        [
          _c("v-col", { staticClass: "ta-c", attrs: { cols: "12" } }, [
            _c("img", { attrs: { src: _vm.ic_smb_welcome } }),
          ]),
          _c("v-col", { staticClass: "ta-c", attrs: { cols: "12" } }, [
            _c("label", { staticClass: "declined-lbl" }, [
              _vm._v("Thank you! Your bid has been recorded."),
            ]),
          ]),
          _c("v-col", { staticClass: "ta-c", attrs: { cols: "12" } }, [
            _c("img", { attrs: { src: _vm.ic_tick_green } }),
          ]),
          _c(
            "v-col",
            {
              staticClass: "ta-c mt-n4",
              attrs: { xl: "4", lg: "4", md: "5", sm: "10", cols: "10" },
            },
            [
              _c("label", { staticClass: "submit-again" }, [
                _vm._v(
                  "If you’re selected to move the shipment, we'll get back to you as soon as possible. If you’re not selected, we'll still let you know! Keep an eye out for more from us soon."
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }